import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ITmkKeyFormMeta {
    tmkKey: FormInputMeta;
    tmkKCV: FormInputMeta;

    schema: any;
}

const tmkKeyFormMeta = {} as ITmkKeyFormMeta;

tmkKeyFormMeta.tmkKey = {
    name: "tmkKey",
    type: "string",
    label: "Clé TMK",
    placeholder: "Clé TMK",
    validation: yup.string().required("Champ obligatoire !"),
};

tmkKeyFormMeta.tmkKCV = {
    name: "tmkKCV",
    type: "string",
    label: "TMK KCV",
    placeholder: "TMK KCV",
    validation: yup.string().required("Champ obligatoire !"),
};

export default tmkKeyFormMeta;